<template>
    <!-- Footer -->
    <footer class="bg-beigey py-5">
        <div class="container">
            <div class="text-center mb-5 border-bottom pb-5 border-secondary-subtle">
                <h4 class="fw-bold mb-3">Newsletter</h4>
                <p class="text-muted small mb-3">Sign up for our newsletter and get updates on our latest offers.</p>
                <div class="input-group mb-3 mx-auto" style="max-width: 400px;">
                    <input type="text" class="form-control border-0" placeholder="Enter your email address">
                    <button class="btn btn-dark px-4" type="button">Subscribe</button>
                </div>
            </div>

            <div class="row gy-4">
                <div class="col-md-4">
                    <a class="fw-bold fs-4 text-brown text-decoration-none" href="/">
                        <img v-if="logo" :src="logo" alt="Logo" height="40">
                        <span v-else>FIT<span class="fw-light">furniture</span></span>
                    </a>
                    <p class="small text-muted mt-3 pe-5">Our team consists of highly skilled experts in every area...
                    </p>
                    <p class="small text-muted mt-5">&copy; Copyright by Fekra {{ new Date().getFullYear() }}</p>
                </div>
                <div class="col-6 col-md-2">
                    <h6 class="fw-bold mb-3">Useful Links</h6>
                    <ul class="list-unstyled small text-muted gap-2 d-flex flex-column">
                        <li><a href="/" class="text-decoration-none text-muted">Home</a></li>
                        <li><a href="/products" class="text-decoration-none text-muted">Products</a></li>
                        <li><a href="#" class="text-decoration-none text-muted">About Us</a></li>
                        <li><a href="#" class="text-decoration-none text-muted">Contact Us</a></li>
                    </ul>
                </div>
                <div class="col-6 col-md-2">
                    <h6 class="fw-bold mb-3">Shop</h6>
                    <ul class="list-unstyled small text-muted gap-2 d-flex flex-column">
                        <li v-for="category in categories" :key="category.id">
                            <a :href="`/products?category_id[]=${category.id}`" class="text-decoration-none text-muted">{{ category.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-6 col-md-2">
                    <h6 class="fw-bold mb-3">Social Media</h6>
                    <ul class="list-unstyled small text-muted gap-2 d-flex flex-column">
                        <li><a href="#" class="text-decoration-none text-muted"><i class="bi bi-facebook me-2"></i>
                                Facebook</a></li>
                        <li><a href="#" class="text-decoration-none text-muted"><i class="bi bi-instagram me-2"></i>
                                Instagram</a></li>
                        <li><a href="#" class="text-decoration-none text-muted"><i class="bi bi-twitter me-2"></i>
                                Twitter</a></li>
                    </ul>
                </div>
                <div class="col-6 col-md-2">
                    <h6 class="fw-bold mb-3">Customer Service</h6>
                    <ul class="list-unstyled small text-muted gap-2 d-flex flex-column">
                        <li><a href="#" class="text-decoration-none text-muted">FAQs</a></li>
                        <li><a href="#" class="text-decoration-none text-muted">Terms & Conditions</a></li>
                        <li><a href="#" class="text-decoration-none text-muted">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterSection",
    data() {
        return {
            categories: []
        }
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        fetchCategories() {
            axios.get('/api/frontend/categories?only_parents=1')
                .then(response => {
                    this.categories = response.data.data;
                })
                .catch(error => {
                    console.error('Error fetching footer categories:', error);
                });
        }
    },
    props: {
        logo: {
            type: String,
            default: null
        }
    }
}
</script>
